import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { hideButtonForAdvertContacts, showButtonForAdvertContacts } from '#baseMenu/reducers/slice-menu';
import { UseButtonForAdvertContactsControlResultType } from '#baseMenu/hooks';

const useButtonForAdvertContactsControl = (): UseButtonForAdvertContactsControlResultType => {
  const dispatch = useDispatch();

  const triggerShow = useCallback(() => {
    dispatch(showButtonForAdvertContacts());
  }, [dispatch]);

  const triggerHide = useCallback(() => {
    dispatch(hideButtonForAdvertContacts());
  }, [dispatch]);

  return {
    show: triggerShow,
    hide: triggerHide,
  };
};

export { useButtonForAdvertContactsControl };
